import { useRef } from 'react';

function useInitializer(initializer) {
  const ref = useRef();
  if (!ref.current) {
    ref.current = initializer();
  }
  return ref.current;
}

export { useInitializer };
//# sourceMappingURL=useInitializer.js.map
